import React, { Fragment, useCallback, useEffect, useReducer, useState } from 'react';
import {
    Button,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { onChangeFunction, RadioButtons, UrlEnum } from '../../../shared';
import { FormSelect } from '../../blocks';
import { getCipLabel } from '../../academic-affair-report/program-criteria-form';
import { getOptionLabel } from '../../academic-affair-program/search-academic-programs-form';
import { useHistory } from 'react-router-dom';
import format from 'date-fns/format';
import { academicProgramsService } from '../../../services';
import queryString from 'query-string';
import { RadioCheckGroup } from '../../academic-affair-report/components/RadioCheckGroup';
import {
    faArrowLeft,
    faArrowRight,
    faPaperclip,
    faTimes,
    faUpload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { sq } from 'date-fns/locale';
import eventEmitter from "../../../shared/eventEmitter";

export const ProgramRequestNewProgramRequestModal = ({
    isOpen,
    toggle,
}) => {
    const programStatusOptions = [
        { label: 'New', value: 0 },
        { label: 'Active', value: 1 },
        { label: 'Suspended', value: 3 },
        { label: 'Eliminated', value: 4 },
        { label: 'Merged', value: 5 },
    ];
    const locationStatusOptions = [
        { label: 'Active', value: 1 },
        { label: 'Suspended', value: 3 },
        { label: 'Eliminated', value: 4 },
    ];
    const history = useHistory();
    const [onlineDropdownDisabled, setOnlineDropdownDisabled] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [allPrograms, setAllPrograms] = useState([]);
    const [allFieldsFilled, setAllFieldsFilled] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [mergedProgramId, setMergedProgramId] = useState(-1);
    const [degreeLevels, setDegreeLevels] = useState([]);
    const [locationsToAdd, setLocationsToAdd] = useState([]);
    const [modalPageNumber, setModalPageNumber] = useState('typeSelection');
    const hideDegreeLevels = ['03', '05', '07', '17', '18'];
    const [files, setFiles] = useState(null);

    const onFileChange = useCallback(e => {
        setFiles(e.target.files);
    }, []);
    const [INITIAL_STATE, setINITIAL_STATE] = useState({
        institution: null,
        locations: [],
        programName: '',
        degreeLevel: null,
        cipCode: '',
        approvalDate: format(new Date(), 'yyyy-MM-dd'),
        distanceEdApproved: false,
        distanceEdOnlineApproved: false,
        comments: '',
        selectedOption: '',
        requestType: '',
        creditRequirementMinimum: '',
        creditRequirementMaximum: '',
        endDate: '',
        programDistanceEd: null,
        programDistanceEdOnline: null,
        programURL: '',
        keywords: '',
        description: '',
        programStatusOptions: '',
    });

    const handleRadioButtonChange = evt => {
        const name = evt.target.name;
        const newValue = evt.target.value;
        setUserInput({ [name]: newValue });
    };
    const handleTypeSelection = () => {
        if (userInput.selectedOption === 'option1') {
            setModalPageNumber('newRequest');
        } else {
            setModalPageNumber('editRequest');
        }
    };
    const reducer = (state, newState) => ({ ...state, ...newState });

    const [userInput, setUserInput] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        INITIAL_STATE
    );

    const toggleModal = () => {
        toggle();
        setFiles(null);
        setUserInput({ editProgram: [] });
        setUserInput({ institution: [] });
        setModalPageNumber('typeSelection');
        setOnlineDropdownDisabled(false);
        setUserInput(INITIAL_STATE);
    };

    useEffect(() => {
        if (modalPageNumber === 'typeSelection') {
            setUserInput({ editProgram: [] });
            setFiles(null);
            setUserInput({ institution: [] });
            setUserInput(INITIAL_STATE);
        }
        if (userInput.requestType === '8') {
            const instCopy = userInput.institution;
            setOptions({
                existingPrograms: allPrograms
                    .filter(x => x.degreeLevelCode === userInput.degreeLevel.value)
                    .map(program => ({
                        label: `${program.programId} - ${program.programFormalName}`,
                        value: program.programId,
                    })),
            });
            setUserInput({ editProgram: [] });
            setUserInput({ creditRequirementMinimum: [] });
            setUserInput({ creditRequirementMaximum: [] });
            setUserInput({ programName: [] });
            setUserInput({ cipCode: [] });
        }
    }, [modalPageNumber]);

    // Custom Split Program Only
    const [splitPrograms, setSplitPrograms] = useState([]);
    const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
    const currentSplitProgram = splitPrograms[currentSplitIndex];

    const [options, setOptions] = useReducer(reducer, {});
    const fetchOptions = useCallback(async () => {
        academicProgramsService.getInstitutions().then(res => {
            setOptions({
                institutions: res?.map(x => {
                    return { value: x.label, label: x.value };
                }),
            });
        });

        academicProgramsService.getProgramRequestTypes().then(res => {
            setOptions({
                requestTypes: res?.map(x => {
                    return { value: x.typeId, label: x.typeDesc };
                }),
            });
        });

        academicProgramsService.getCips().then(res => {
            setOptions({
                cipCode: res[2],
            });
        });
        academicProgramsService.getDegreeLevels().then(res => {
            setOptions({
                degreeLevels: res?.map(x => {
                    return { value: x.label, label: x.value };
                }),
            });
        });
    }, []);

    useEffect(() => {
        setUserInput({ locations: [] });
        setOptions({ locations: [] });
        if (institutions.label !== undefined) {
            const query = queryString.stringify(
                { institutions: institutions.value },
                {
                    arrayFormat: 'separator',
                    skipEmptyString: true,
                }
            );
            academicProgramsService.getLocations(query).then(res => {
                setOptions({ locations: res?.locations });
            });
        } else if (userInput.institution) {
            const query = queryString.stringify(
                { institutions: userInput.institution.value },
                {
                    arrayFormat: 'separator',
                    skipEmptyString: true,
                }
            );
            academicProgramsService.getLocations(query).then(res => {
                setOptions({ locations: res.locations });
            });
        }
    }, [userInput.institution, institutions]);

    useEffect(() => {
        fetchOptions();
    }, [fetchOptions]);
    useEffect(() => {
        if (options.institutions) {
            if (options.institutions.length == 1) {
                const singleLoc = {
                    label: options.institutions[0].label,
                    value: options.institutions[0].value,
                };
                setUserInput((userInput.institution = [singleLoc]));
            }
        }
    }, [options.institutions]);

    useEffect(() => {
        if (userInput.institution) {
            setAllPrograms([]);
            setOptions({ existingPrograms: [] });
            setUserInput({ editProgram: [] });
            if (userInput.institution.value || userInput.institution.length > 0) {
                const query = queryString.stringify(
                    {
                        institutions:
                            userInput.institution.value ?? userInput.institution[0].value,
                    },
                    {
                        arrayFormat: 'separator',
                        skipEmptyString: true,
                    }
                );
                academicProgramsService
                    .getAllProgramDetailsFromInstitution(query)
                    .then(res => {
                        const formattedPrograms = res?.programs?.flat().map(program => ({
                            label: `${program.programId} - ${program.programFormalName}`,
                            value: program.programId,
                        }));
                        setAllPrograms(res?.programs.flat());
                        setOptions({ existingPrograms: formattedPrograms });
                    });
            }
        }
    }, [userInput.institution]);

    const rowStyles = {
        container: provided => ({
            ...provided,
            width: 120,
        }),
    };

    const statusChangeOptions = [
        { label: 'Active', value: 1 },
        { label: 'Suspended', value: 3 },
        { label: 'Eliminated', value: 4 },
    ];

    const getSelectOption = val => {
        return statusChangeOptions.find(x => x.value === val);
    };
    const renderApprovedLocationRows = () => {
        let rows = [];
        locationsToAdd.map(location => {
            rows.push(
                <tr key={location.value}>
                    <td>{location.label}</td>
                    <td className="table-actions">
                        <div className="text-success">Pending Addition</div>
                        <div className="text-danger">
                            <FontAwesomeIcon
                                icon={faTimes}
                                className="cursor-pointer ml-2"
                                onClick={() =>
                                    setLocationsToAdd(prev =>
                                        prev.filter(loc => loc.value !== location.value)
                                    )
                                }
                            />
                        </div>
                    </td>
                </tr>
            );
        });
        userInput.locations.map(location => {
            rows.push(
                <tr key={location.value}>
                    <td>{location.label}</td>
                    <td className="table-actions">
                        <Select
                            styles={rowStyles}
                            onChange={evt => {
                                const updatedLocations = userInput.locations.map(loc => {
                                    if (loc.value === location.value) {
                                        return { ...loc, statusId: evt.value };
                                    }
                                    return loc;
                                });
                                setUserInput({ locations: updatedLocations });
                            }}
                            options={statusChangeOptions}
                            value={getSelectOption(location.statusId)}
                            components={{
                                IndicatorSeparator: () => null,
                            }}
                        />
                    </td>
                </tr>
            );
        });
        return rows;
    };

    const updateLocations = evt => {
        const newLocation = {
            label: evt.locations[0].label,
            value: evt.locations[0].value,
            statusId: 1,
        };
        setLocationsToAdd(prev => [...prev, newLocation]);
    };

    const getLocationStatusChanges = locations => {
        return locations.map(location => {
            const status = userInput.selectedOption === 'option1' ? 1 : location.statusId;
            return {
                LocationId: location.value,
                LocationName: location.label,
                StatusId: status,
            };
        });
    };

    const getPostData = () => {
        const postData = {
            degreeLevel: userInput.degreeLevel ? userInput.degreeLevel.value : undefined,
            programId:
                userInput.selectedOption === 'option1' ? -1 : userInput.editProgram.value,
            formalName: userInput.programName ? userInput.programName : undefined,
            cipCode: userInput.cipCode ? userInput.cipCode.value : undefined,
            distanceEdApproved: {
                id: userInput.programDistanceEd,
            },
            distanceEdOnline: {
                id: userInput.programDistanceEdOnline,
            },
            requestTypeId:
                userInput.selectedOption === 'option1' ? 1 : userInput.requestType,
            comments: userInput.comments ? userInput.comments : undefined,
            creditRequirementMinimum: userInput.creditRequirementMinimum
                ? Number(userInput.creditRequirementMinimum)
                : undefined,
            creditRequirementMaximum: userInput.creditRequirementMaximum
                ? Number(userInput.creditRequirementMaximum)
                : undefined,
            institutionId: userInput.institution
                ? userInput.institution.value
                : undefined,
            credential: {
                ProgramURL: userInput.programURL ? userInput.programURL : '',
                Keywords: userInput.keywords ? userInput.keywords : '',
                ProgramDescription: userInput.description ? userInput.description : '',
                CredentialName: userInput.programName ? userInput.programName : undefined,
            },
            locationStatusChanges: getLocationStatusChanges([
                ...locationsToAdd,
                ...userInput.locations,
            ]),
            ProgramStatusId:
                userInput.selectedOption === 'option1'
                    ? 1
                    : userInput.programStatus.value,
            RequestMergeId: mergedProgramId,
        };
        return postData;
    };

    const editProgramRequest = async () => {
        try {
            setSubmitting(true);
            if (userInput.requestType === '7') {
                const validPrograms = splitPrograms.filter(
                    x => x.programName && x.cipCode && x.programDistanceEd
                );
                let linkRequestId = -1;
                for (const program of validPrograms) {
                    const index = validPrograms.indexOf(program);
                    const postData = getPostData();
                    postData.requestTypeId = index === 0 ? '7' : '1';
                    postData.programId = index === 0 ? userInput.editProgram.value : '-1';
                    postData.formalName = program.programName;
                    postData.cipCode = program.cipCode.value;
                    postData.creditRequirementMinimum = program.creditRequirementMinimum
                        ? Number(program.creditRequirementMinimum)
                        : undefined;
                    postData.creditRequirementMaximum = program.creditRequirementMaximum
                        ? Number(program.creditRequirementMaximum)
                        : undefined;
                    postData.distanceEdApproved = {
                        id: program.programDistanceEd,
                    };
                    postData.distanceEdOnline = {
                        id: program.programDistanceEdOnline,
                    };
                    if (index === 0) {
                        const res = await academicProgramsService
                            .createProgramRequest(postData)
                            .then(postRes => {
                                if (files) {
                                    Promise.resolve(
                                        academicProgramsService.uploadFiles(
                                            files,
                                            postRes.programId
                                        )
                                    );
                                }
                                linkRequestId = postRes.programId;
                                setSubmitting(false);
                                return postRes;
                            });
                    } else {
                        postData.RequestSplitId = linkRequestId;
                        const res = await academicProgramsService
                            .createProgramRequest(postData)
                            .then(postRes => {
                                setSubmitting(false);
                                return postRes;
                            });
                    }
                }
            } else {
                const postData = getPostData();
                const res = await academicProgramsService
                    .createProgramRequest(postData)
                    .then(postRes => {
                        setSubmitting(false);
                        if (files) {
                            Promise.resolve(
                                academicProgramsService.uploadFiles(
                                    files,
                                    postRes.programId
                                )
                            );
                        }
                        return postRes;
                    });
            }
            eventEmitter.emit('updateSARData')
            toggleModal();
        } catch (error) {}
    };

    const setEditedProgram = (chosenProgram, overwrite = true) => {
        const filledState = {
            locations: chosenProgram.programLocation.map(x => {
                return {
                    label: x.locationName,
                    value: x.locationId,
                    statusId: x.statusId,
                };
            }),
            programName: chosenProgram.programFormalName ?? '',
            degreeLevel: options.degreeLevels
                ? options.degreeLevels.find(
                      x => chosenProgram.degreeLevelCode === x.value
                  )
                : null,
            cipCode: chosenProgram.cipSixDigitCode
                ? {
                      value: chosenProgram.cipSixDigitCode,
                      label: `${chosenProgram.cipSixDigitCode} - ${chosenProgram.cipSixDigitTitle}`,
                  }
                : '',
            comments: '',
            creditRequirementMinimum: chosenProgram.programCreditReqMin,
            creditRequirementMaximum: chosenProgram.programCreditReqMax,
            programDistanceEd: chosenProgram.programDistanceEdId,
            programDistanceEdOnline: chosenProgram.programDistanceEdOnlineId,
            programStatus: programStatusOptions.find(
                x => x.value === chosenProgram.programStatusId
            ),
        };
        setSplitPrograms([
            {
                programName: filledState.programName,
                cipCode: filledState.cipCode,
                programDistanceEd: filledState.programDistanceEd,
                programDistanceEdOnline: filledState.programDistanceEdOnline,
                creditRequirementMinimum: filledState.creditRequirementMinimum,
                creditRequirementMaximum: filledState.creditRequirementMaximum,
            },
        ]);
        setCurrentSplitIndex(0);
        if (overwrite) setMergedProgramId(chosenProgram.programId);
        setUserInput(filledState);
    };

    useEffect(() => {
        const skipKeys = [
            'endDate',
            'comments',
            'creditRequirementMinimum',
            'creditRequirementMaximum',
        ];
        var anyEmpty = false;
        for (const key in userInput) {
            if (skipKeys.includes(key)) continue;
            if (userInput[key] === null || userInput[key] === '') {
                anyEmpty = true;
            }
        }
        setAllFieldsFilled(!anyEmpty);
    }, [userInput]);

    const closeBtn = (
        <button className="close" onClick={toggleModal}>
            &times;
        </button>
    );

    const handleSplitChange = e => {
        const updatedSplits = [...splitPrograms];
        if (e.cipCode) {
            updatedSplits[currentSplitIndex] = {
                ...updatedSplits[currentSplitIndex],
                ['cipCode']: e.cipCode,
            };
            setSplitPrograms(updatedSplits);
        } else if (e.programDistanceEd) {
            updatedSplits[currentSplitIndex] = {
                ...updatedSplits[currentSplitIndex],
                ['programDistanceEd']: e.programDistanceEd,
            };
            setSplitPrograms(updatedSplits);
        }
        else if (e.programDistanceEdOnline) {
            updatedSplits[currentSplitIndex] = {
                ...updatedSplits[currentSplitIndex],
                ['programDistanceEd']: e.programDistanceEdOnline,
            };
            setSplitPrograms(updatedSplits);
        }
        else {
            const { name, value } = e.target;
            updatedSplits[currentSplitIndex] = {
                ...updatedSplits[currentSplitIndex],
                [name]: value,
            };
            setSplitPrograms(updatedSplits);
        }
    };

    const handleNext = () => {
        if (currentSplitIndex < splitPrograms.length - 1) {
            setCurrentSplitIndex(currentSplitIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentSplitIndex > 0) {
            setCurrentSplitIndex(currentSplitIndex - 1);
        }
    };

    const handleAddProgramSplit = () => {
        setSplitPrograms([
            ...splitPrograms,
            {
                programName: '',
                cipCode: '',
                programDistanceEd: '',
                programDistanceEdOnline: '',
                creditRequirementMinimum: '',
                creditRequirementMaximum: '',
            },
        ]);
        setCurrentSplitIndex(splitPrograms.length);
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader close={closeBtn}>New Staff Action Request</ModalHeader>
            {modalPageNumber === 'typeSelection' && (
                <ModalBody>
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="selectedOption"
                            id="option1"
                            value="option1"
                            checked={userInput.selectedOption === 'option1'}
                            onChange={handleRadioButtonChange}
                        />
                        <label className="form-check-label" htmlFor="option1">
                            Request a NEW program
                        </label>
                    </div>
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="selectedOption"
                            id="option2"
                            value="option2"
                            checked={userInput.selectedOption === 'option2'}
                            onChange={handleRadioButtonChange}
                        />
                        <label className="form-check-label" htmlFor="option2">
                            Request change to an EXISTING program
                        </label>
                    </div>
                    <div className="text-right mt-5">
                        <button
                            type="button"
                            className="btn btn-primary step-next"
                            onClick={() => handleTypeSelection()}
                        >
                            Next <i className="far"></i>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </ModalBody>
            )}
            {modalPageNumber === 'newRequest' && (
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <label>
                                Program Name<sup className="text-danger"> *</sup>
                            </label>
                            <Input
                                type="text"
                                placeholder="Program Name"
                                onChange={evt =>
                                    onChangeFunction.handleChange(evt, setUserInput)
                                }
                                name="programName"
                                value={userInput.programName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormSelect
                                label="CIP Code"
                                onChange={setUserInput}
                                options={
                                    options.cipCode
                                        ? options.cipCode.map(x => {
                                              return {
                                                  value: x.cipCode,
                                                  label: `${x.cipCode} - ${x.cipName}`,
                                              };
                                          })
                                        : []
                                }
                                placeholder="CIP Code"
                                name="cipCode"
                                value={userInput.cipCode}
                                isMulti={false}
                                getOptionLabel={getCipLabel}
                                isClearable
                                showLoading
                                required
                            />
                        </FormGroup>
                        <FormSelect
                            label="Select Institution"
                            onChange={setUserInput}
                            options={options.institutions}
                            placeholder="Please select one"
                            name="institution"
                            value={userInput.institution}
                            isMulti={false}
                            isClearable
                            showLoading
                            required
                        />

                        <FormSelect
                            label="Select Locations"
                            onChange={setUserInput}
                            options={
                                options.locations
                                    ? options.locations.map(x => {
                                          return { value: x.key, label: x.value };
                                      })
                                    : []
                            }
                            closeAfterSelection={false}
                            placeholder="Select Locations"
                            name="locations"
                            value={userInput.locations}
                            isMulti
                            isClearable
                            showLoading
                            required
                        />

                        <div className="form-row align-items-center">
                            <div className="col-lg-12">
                                <FormSelect
                                    label="Degree/Award Level"
                                    onChange={setUserInput}
                                    options={options.degreeLevels}
                                    placeholder="All"
                                    name="degreeLevel"
                                    value={userInput.degreeLevel}
                                    required
                                    getOptionLabel={getOptionLabel}
                                    isMulti={false}
                                    isClearable
                                />
                            </div>
                        </div>

                        <div className="form-group align-items-center">
                            <div className="">
                                <label className="d-block">
                                    Delivery Mode<sup className="text-danger"> *</sup>
                                </label>
                                <RadioCheckGroup
                                  onChange={setUserInput}
                                  name="programDistanceEd"
                                  value={userInput.programDistanceEd}
                                  options={[
                                      {
                                          value: 1,
                                          label: "On Campus Only"
                                      },
                                      {
                                          value: 2,
                                          label: "Online Only"
                                      },
                                      {
                                          value: 3,
                                          label: "On Campus & Online"
                                      }
                                  ]}
                                />
                            </div>
                        </div>
                        <div className="form-group align-items-center">
                            <div className="">
                                  <label className="d-block">
                                      Nature of Online Program<sup className="text-danger"> *</sup>
                                  </label>
                                  <RadioCheckGroup
                                    onChange={setUserInput}
                                    name="programDistanceEdOnline"
                                    value={userInput.programDistanceEdOnline}
                                    options={[
                                        {
                                            value: 0,
                                            label: "None"
                                        },
                                        {
                                            value: 1,
                                            label: "100% Online"
                                        },
                                        {
                                            value: 2,
                                            label: "Blended"
                                        }
                                    ]}
                                  />
                            </div>
                        </div>
                        <div className="form-group align-items-center">
                            <div className="">
                                <FormGroup>
                                    <label>Credit Requirement Minimum</label>
                                    <Input
                                      type="number"
                                      style={{ textAlign: "left" }}
                                      placeholder="Minimum Credits"
                                      onChange={evt =>
                                        onChangeFunction.handleChange(
                                          evt,
                                          setUserInput
                                        )
                                      }
                                      name="creditRequirementMinimum"
                                      value={userInput.creditRequirementMinimum}
                                    />
                                </FormGroup>
                            </div>
                            <div className="">
                                <FormGroup>
                                    <label>Credit Requirement Maximum</label>
                                    <Input
                                      type="number"
                                      style={{ textAlign: "left" }}
                                      placeholder="Maximum Credits"
                                      onChange={evt =>
                                        onChangeFunction.handleChange(
                                          evt,
                                          setUserInput
                                        )
                                      }
                                      name="creditRequirementMaximum"
                                      value={userInput.creditRequirementMaximum}
                                    />
                                </FormGroup>
                            </div>
                        </div>
                        <div className="form-row align-items-center">
                            <div className="col-lg-12">
                                <label>Support Documentation</label>
                            </div>
                        </div>
                        <div className="w-100 hidden-file-input-small">
                            <input
                              type="file"
                              accept=".csv,.zip,.pdf,.xls,.xlxs"
                              onChange={onFileChange}
                              multiple={true}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                            >
                                <i className="far"></i>{" "}
                                <FontAwesomeIcon icon={faUpload} />
                                Upload
                            </button>
                        </div>
                        {files &&
                          Array.from(files).map((x, index) => (
                            <h5 key={index} className="mb-0 mt-4 text-italic">
                            <FontAwesomeIcon icon={faPaperclip} /> {x.name}
                                </h5>
                            ))}
                        <FormGroup>
                            <label>
                                Please provide any additional information necessary to
                                process your request.
                            </label>
                            <Input
                                type="textarea"
                                rows="3"
                                placeholder="Place Comments Here"
                                onChange={evt =>
                                    onChangeFunction.handleChange(evt, setUserInput)
                                }
                                name="comments"
                                value={userInput.comments}
                            />
                        </FormGroup>
                    </Form>
                    <div className="text-right mt-5">
                        <button
                            type="button"
                            className="btn btn-outline-primary step-back mr-3"
                            onClick={() => setModalPageNumber('typeSelection')}
                            disabled={submitting}
                        >
                            <i className="far"></i>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary step-next"
                            onClick={() => editProgramRequest()}
                            disabled={submitting}
                        >
                            Submit
                        </button>
                    </div>
                </ModalBody>
            )}
            {modalPageNumber === 'editRequest' && (
                <ModalBody>
                    <Form>
                        <FormSelect
                            label="Select Institution"
                            onChange={setUserInput}
                            options={options.institutions}
                            placeholder="Please select one"
                            name="institution"
                            value={userInput.institution}
                            isMulti={false}
                            isClearable
                            showLoading
                            required
                        />
                        {userInput.institution && (
                            <FormSelect
                                label="Select Program"
                                onChange={setUserInput}
                                options={options.existingPrograms}
                                placeholder="Please select one"
                                name="editProgram"
                                value={userInput.editProgram}
                                isMulti={false}
                                isClearable
                                showLoading
                                required
                            />
                        )}
                        {options.requestTypes?.slice(1).map((name, index) => (
                            <div className="form-check mb-3" key={index}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="requestType"
                                    id={name.label}
                                    value={name.value}
                                    checked={userInput.requestType == name.value}
                                    onChange={handleRadioButtonChange}
                                />
                                <label className="form-check-label" htmlFor={name.label}>
                                    {name.label}
                                </label>
                            </div>
                        ))}
                    </Form>
                    <div className="text-right mt-5">
                        <button
                            type="button"
                            className="btn btn-outline-primary step-back mr-3"
                            onClick={() => setModalPageNumber('typeSelection')}
                        >
                            <i className="far"></i>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary step-next"
                            disabled={userInput.editProgram === undefined}
                            onClick={() => {
                                const chosenProgram = allPrograms.find(
                                    item => item.programId === userInput.editProgram.value
                                );
                                if (chosenProgram === undefined) toggleModal();
                                setEditedProgram(chosenProgram);
                                setModalPageNumber('EditExisting');
                            }}
                        >
                            Next
                        </button>
                    </div>
                </ModalBody>
            )}
            {modalPageNumber === 'EditExisting' && (
                <ModalBody>
                    <Form>
                        <FormSelect
                            label="Institution"
                            onChange={setUserInput}
                            options={options.institutions}
                            placeholder="Please select one"
                            name="institution"
                            value={userInput.institution}
                            isMulti={false}
                            disabled={true}
                            isClearable
                            showLoading
                        />
                        {userInput.requestType === '7' && (
                            <>
                                <FormGroup>
                                    <label>
                                        {currentSplitIndex === 0 ? '' : 'New'} Program
                                        Name
                                    </label>
                                    <Input
                                        type="text"
                                        placeholder="Program Name"
                                        onChange={handleSplitChange}
                                        name="programName"
                                        value={currentSplitProgram.programName}
                                    />
                                </FormGroup>
                                <FormSelect
                                    label={
                                        currentSplitIndex === 0
                                            ? 'CIP Code'
                                            : 'New CIP Code'
                                    }
                                    onChange={handleSplitChange}
                                    options={
                                        options.cipCode
                                            ? options.cipCode.map(x => {
                                                  return {
                                                      value: x.cipCode,
                                                      label: `${x.cipCode} - ${x.cipName}`,
                                                  };
                                              })
                                            : []
                                    }
                                    placeholder="CIP Code"
                                    name="cipCode"
                                    value={currentSplitProgram.cipCode}
                                    isMulti={false}
                                    getOptionLabel={getCipLabel}
                                    isClearable
                                    showLoading
                                />
                                <div className="form-group">
                                    <label className="d-block">
                                        {currentSplitIndex === 0 ? '' : 'New'} Delivery
                                        Mode
                                    </label>
                                    <RadioCheckGroup
                                        onChange={handleSplitChange}
                                        name="programDistanceEd"
                                        value={currentSplitProgram.programDistanceEd}
                                        options={[
                                            {
                                                value: 1,
                                                label: 'On Campus Only',
                                            },
                                            {
                                                value: 2,
                                                label: 'Online Only',
                                            },
                                            {
                                                value: 3,
                                                label: 'On Campus & Online',
                                            },
                                        ]}
                                    />
                                </div>

                                {<div className="form-group">
                                    <label className="d-block">
                                        Nature of Online Program<sup className="text-danger"> *</sup>
                                    </label>
                                    <RadioCheckGroup
                                      onChange={handleSplitChange}
                                      name="programDistanceEdOnline"
                                      value={currentSplitProgram.programDistanceEdOnline}
                                      options={[
                                          {
                                              value: 0,
                                              label: "None"
                                          },
                                          {
                                              value: 1,
                                              label: '100% Online',
                                          },
                                          {
                                              value: 2,
                                              label: 'Blended',
                                          }
                                      ]}
                                    />
                                </div>}


                                <div>
                                    <FormGroup>
                                        <label>
                                            {currentSplitIndex === 0 ? '' : 'New'} Credit
                                            Requirement Minimum
                                        </label>
                                        <Input
                                            type="number"
                                            style={{ textAlign: 'left' }}
                                            placeholder="Minimum Credits"
                                            onChange={handleSplitChange}
                                            name="creditRequirementMinimum"
                                            value={
                                                currentSplitProgram.creditRequirementMinimum
                                            }
                                        />
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <label>
                                            {currentSplitIndex === 0 ? '' : 'New'} Credit
                                            Requirement Maximum
                                        </label>
                                        <Input
                                            type="number"
                                            style={{ textAlign: 'left' }}
                                            placeholder="Maximum Credits"
                                            onChange={handleSplitChange}
                                            name="creditRequirementMaximum"
                                            value={
                                                currentSplitProgram.creditRequirementMaximum
                                            }
                                        />
                                    </FormGroup>
                                </div>
                                <div className="d-flex justify-content-between mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary step-next"
                                        onClick={() => handleAddProgramSplit()}
                                    >
                                        Add New Split
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary step-back"
                                        onClick={() => handlePrevious()}
                                        disabled={currentSplitIndex === 0}
                                    >
                                        Previous
                                    </button>
                                    <span>
                                        Program {currentSplitIndex + 1} of{' '}
                                        {splitPrograms.length}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary step-next"
                                        onClick={() => handleNext()}
                                        disabled={
                                            currentSplitIndex === splitPrograms.length - 1
                                        }
                                    >
                                        Next
                                    </button>
                                </div>
                            </>
                        )}
                        {userInput.requestType === '8' && (
                          <>
                              <FormSelect
                                label="Select Program to Merge Into"
                                onChange={evt => {
                                    setUserInput({ editProgram: evt.editProgram });
                                    const chosenProgram = allPrograms.find(
                                      item =>
                                        item.programId === evt.editProgram.value
                                    );
                                    if (chosenProgram === undefined) toggleModal();
                                    setEditedProgram(chosenProgram, false);
                                }}
                                options={options.existingPrograms}
                                placeholder="Please select one"
                                name="editProgram"
                                value={userInput.editProgram}
                                isMulti={false}
                                isClearable
                                showLoading
                                required
                              />
                              <FormGroup>
                                  <label>Program Name</label>
                                  <Input
                                    type="text"
                                    placeholder="Program Name"
                                    onChange={evt =>
                                      onChangeFunction.handleChange(
                                        evt,
                                        setUserInput
                                      )
                                    }
                                    name="programName"
                                    value={userInput.programName}
                                  />
                              </FormGroup>
                              <FormSelect
                                label="CIP Code"
                                onChange={setUserInput}
                                options={
                                    options.cipCode
                                      ? options.cipCode.map(x => {
                                          return {
                                              value: x.cipCode,
                                              label: `${x.cipCode} - ${x.cipName}`
                                          };
                                      })
                                      : []
                                }
                                placeholder="CIP Code"
                                name="cipCode"
                                value={userInput.cipCode}
                                isMulti={false}
                                getOptionLabel={getCipLabel}
                                isClearable
                                showLoading
                                required
                              />
                              <div className="form-group align-items-center">
                                  <div className="">
                                      <label className="d-block">
                                          Delivery Mode<sup className="text-danger"> *</sup>
                                      </label>
                                      <RadioCheckGroup
                                        onChange={setUserInput}
                                        name="programDistanceEd"
                                        value={userInput.programDistanceEd}
                                        options={[
                                            {
                                                value: 1,
                                                label: "On Campus Only"
                                            },
                                            {
                                                value: 2,
                                                label: "Online Only"
                                            },
                                            {
                                                value: 3,
                                                label: "On Campus & Online"
                                            }
                                        ]}
                                      />
                                  </div>
                              </div>
                              <div className="form-group align-items-center">
                                  <div className="">
                                      <label className="d-block">
                                          Nature of Online Program<sup className="text-danger"> *</sup>
                                      </label>
                                      <RadioCheckGroup
                                        onChange={setUserInput}
                                        name="programDistanceEdOnline"
                                        value={userInput.programDistanceEdOnline}
                                        options={[
                                            {
                                                value: 0,
                                                label: "None"
                                            },
                                            {
                                                value: 1,
                                                label: "100% Online"
                                            },
                                            {
                                                value: 2,
                                                label: "Blended"
                                            }
                                        ]}
                                      />
                                  </div>
                              </div>

                              <div className="">
                                  <FormGroup>
                                      <label>Credit Requirement Minimum</label>
                                      <Input
                                        type="number"
                                        style={{ textAlign: "left" }}
                                        placeholder="Minimum Credits"
                                        onChange={evt =>
                                          onChangeFunction.handleChange(
                                            evt,
                                            setUserInput
                                          )
                                        }
                                        name="creditRequirementMinimum"
                                        value={userInput.creditRequirementMinimum}
                                      />
                                  </FormGroup>
                              </div>

                              <div className="">
                                  <FormGroup>
                                      <label>Credit Requirement Maximum</label>
                                      <Input
                                        type="number"
                                        style={{ textAlign: "left" }}
                                        placeholder="Maximum Credits"
                                        onChange={evt =>
                                          onChangeFunction.handleChange(
                                            evt,
                                            setUserInput
                                          )
                                        }
                                        name="creditRequirementMaximum"
                                        value={userInput.creditRequirementMaximum}
                                      />
                                  </FormGroup>
                              </div>
                          </>
                        )}
                        {userInput.requestType !== "8" && userInput.requestType !== "7" && (
                          <FormGroup>
                              <label>Program Name</label>
                              <Input
                                type="text"
                                placeholder="Program Name"
                                onChange={evt =>
                                  onChangeFunction.handleChange(evt, setUserInput)
                                }
                                name="programName"
                                disabled={userInput.requestType !== "2"}
                                value={userInput.programName}
                              />
                          </FormGroup>
                        )}
                        <FormGroup>
                            {userInput.requestType === "4" && (
                              <FormSelect
                                label="CIP Code"
                                onChange={setUserInput}
                                options={
                                    options.cipCode
                                      ? options.cipCode.map(x => {
                                          return {
                                                      value: x.cipCode,
                                                      label: `${x.cipCode} - ${x.cipName}`,
                                                  };
                                              })
                                            : []
                                    }
                                    placeholder="CIP Code"
                                    name="cipCode"
                                    value={userInput.cipCode}
                                    isMulti={false}
                                    getOptionLabel={getCipLabel}
                                    isClearable
                                    showLoading
                                    required
                                />
                            )}
                        </FormGroup>

                        {userInput.requestType === '9' && (
                            <FormSelect
                                label="Select Locations To Add"
                                onChange={evt => updateLocations(evt)}
                                options={
                                    options.locations
                                        ? options.locations
                                              .filter(loc => {
                                                  const alreadySelected = userInput.locations.some(
                                                      selected =>
                                                          selected.value === loc.key
                                                  );
                                                  const alreadyAdded = locationsToAdd.some(
                                                      added => added.value === loc.key
                                                  );
                                                  return (
                                                      !alreadySelected && !alreadyAdded
                                                  );
                                              })
                                              .map(x => {
                                                  return { value: x.key, label: x.value };
                                              })
                                        : []
                                }
                                closeAfterSelection={true}
                                placeholder="Select a location to add to the program (if any)"
                                name="locations"
                                value={[]}
                                isMulti
                                isClearable
                                required
                            />
                        )}

                        <div className="align-items-center">
                            {userInput.requestType === '5' && (
                              <>
                                  <div className="form-group align-items-center">
                                      <div className="">
                                          <label className="d-block">
                                              Delivery Mode<sup className="text-danger"> *</sup>
                                          </label>
                                          <RadioCheckGroup
                                            onChange={setUserInput}
                                            name="programDistanceEd"
                                            value={userInput.programDistanceEd}
                                            options={[
                                                {
                                                    value: 1,
                                                    label: "On Campus Only"
                                                },
                                                {
                                                    value: 2,
                                                    label: "Online Only"
                                                },
                                                {
                                                    value: 3,
                                                    label: "On Campus & Online"
                                                }
                                            ]}
                                          />
                                      </div>
                                  </div>
                                  <div className="form-group align-items-center">
                                      <div className="">
                                          <label className="d-block">
                                              Nature of Online Program<sup className="text-danger"> *</sup>
                                          </label>
                                          <RadioCheckGroup
                                            onChange={setUserInput}
                                            name="programDistanceEdOnline"
                                            value={userInput.programDistanceEdOnline}
                                            options={[
                                                {
                                                    value: 0,
                                                    label: "None"
                                                },
                                                {
                                                    value: 1,
                                                    label: "100% Online"
                                                },
                                                {
                                                    value: 2,
                                                    label: "Blended"
                                                }
                                            ]}
                                          />
                                      </div>
                                  </div>
                              </>
                            )}

                            {userInput.requestType === "6" && (
                              <div className="col-lg-6">
                                  <FormSelect
                                    label="Program Status"
                                    onChange={setUserInput}
                                    options={programStatusOptions}
                                    placeholder="Status"
                                    name="programStatus"
                                    value={userInput.programStatus}
                                    isMulti={false}
                                    isClearable
                                    showLoading
                                    required
                                  />
                              </div>
                            )}

                            {userInput.requestType === "3" && (
                              <>
                                  <div className="col-lg">
                                  <FormGroup>
                                          <label>Credit Requirement Minimum</label>
                                          <Input
                                            type="number"
                                            style={{ textAlign: 'left' }}
                                                placeholder="Minimum Credits"
                                                onChange={evt =>
                                                    onChangeFunction.handleChange(
                                                        evt,
                                                        setUserInput
                                                    )
                                                }
                                                name="creditRequirementMinimum"
                                                value={userInput.creditRequirementMinimum}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div className="col-lg">
                                        <FormGroup>
                                            <label>Credit Requirement Maximum</label>
                                            <Input
                                                type="number"
                                                style={{ textAlign: 'left' }}
                                                placeholder="Maximum Credits"
                                                onChange={evt =>
                                                    onChangeFunction.handleChange(
                                                        evt,
                                                        setUserInput
                                                    )
                                                }
                                                name="creditRequirementMaximum"
                                                value={userInput.creditRequirementMaximum}
                                            />
                                        </FormGroup>
                                    </div>
                                </>
                            )}
                        </div>
                        {userInput.requestType === '9' && (
                            <div>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Location</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>{renderApprovedLocationRows()}</tbody>
                                </table>
                            </div>
                        )}
                        <div className="form-row align-items-center">
                            <div className="col-lg-12">
                                <label>Support Documentation</label>
                            </div>
                        </div>
                        <div className="w-100 hidden-file-input-small">
                            <input
                                type="file"
                                accept=".csv,.zip,.pdf,.xls,.xlxs"
                                onChange={onFileChange}
                                multiple={true}
                            />
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                            >
                                <i className="far"></i>{' '}
                                <FontAwesomeIcon icon={faUpload} />
                                Upload
                            </button>
                        </div>
                        {files &&
                            Array.from(files).map((x, index) => (
                                <h5 key={index} className="mb-0 mt-4 text-italic">
                                    <FontAwesomeIcon icon={faPaperclip} /> {x.name}
                                </h5>
                            ))}
                        <FormGroup>
                            <label>
                                Please provide any additional information necessary to
                                process your request.
                            </label>
                            <Input
                                type="textarea"
                                rows="3"
                                placeholder="Place Comments Here"
                                onChange={evt =>
                                    onChangeFunction.handleChange(evt, setUserInput)
                                }
                                name="comments"
                                value={userInput.comments}
                            />
                        </FormGroup>
                    </Form>
                    <div className="text-right mt-5">
                        <button
                            type="button"
                            className="btn btn-outline-primary step-back mr-3"
                            onClick={() => setModalPageNumber('editRequest')}
                        >
                            <i className="far"></i>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary step-next"
                            onClick={() => editProgramRequest()}
                        >
                            Submit
                        </button>
                    </div>
                </ModalBody>
            )}
        </Modal>
    );
};
